import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/investment-return-calculator',
  component: () => import('../../routes/InvestmentReturnCalculator.svelte'),
  card: {
    id: 'investment-return-calculator',
    title: 'Investment Return Calculator',
    description: 'Calculate total return, annualized return (CAGR), and inflation-adjusted real return on any investment. See year-by-year growth breakdown with real vs. nominal values.',
    icon: 'trending_up',
    iconBgClass: 'bg-green-50',
    iconTextClass: 'text-green-600',
    href: '/investment-return-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Investment Return Calculator – Total Return & CAGR Calculator',
    description: 'Free investment return calculator to calculate total return, annualized return (CAGR), and inflation-adjusted real return on any investment. Enter initial investment, final value, and holding period to see simple return, CAGR, and real return with year-by-year breakdowns.',
  },
};

export default meta;
